<template>
  <div class="stars-filter">
    <div
      v-for="starNumber in [1, 2, 3, 4, 5]"
      :key="starNumber"
      @click="filterStar(starNumber)"
      @mouseover="hoverStarFilter = starNumber"
      @mouseout="hoverStarFilter = 0"
      :class="
        hoverStarFilter <= starFilter &&
        starFilter > starNumber - 1 &&
        (hoverStarFilter > starNumber - 1 || hoverStarFilter == 0)
          ? 'active-star'
          : hoverStarFilter > starNumber - 1 && hoverStarFilter >= starFilter
          ? 'active-star'
          : ''
      "
    />
  </div>
</template>

<script>
export default {
  name: 'StarFilter',
  data() {
    return {
      starFilter: '',
      hoverStarFilter: 0
    };
  },
  methods: {
    resetValue() {
      this.starFilter = '';
    },
    filterStar(starNumber) {
      this.starFilter = this.starFilter === starNumber ? '' : starNumber;
      this.$emit(
        'filtered-star',
        'stars',
        this.starFilter === '' ? this.starFilter : this.starFilter - 1
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.stars-filter {
  display: flex;
  flex-direction: row;
  align-items: center;
  & > div {
    margin: 0 3px;
    background-image: url('../../assets/icon/unselected-star.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    transition: 0.5s ease;
    width: 22px;
    height: 22px;
  }
  & > div:hover,
  .active-star {
    background-image: url('../../assets/icon/selected-star.svg') !important;
  }
  & > img {
    margin: 0 1px;
    opacity: 0.4;
    cursor: pointer;
    transition: 0.5s ease;
    &:hover {
      opacity: 1;
    }
  }
}
</style>
